<template>
  <form
    id="verify"
    @submit.prevent="verify"
  >
    <input
      id="2fa_payload"
      :value="two_fa_payload"
      type="hidden"
    >
    <div class="form-group">
      <div v-if="!useBackupCode">
        Use your authentication app to <strong>get a code</strong> and enter it below.
      </div>
      <div v-else>
        Please enter your <strong>backup code</strong> below.
      </div>
    </div>
    <div
      class="form-group"
      :class="{'text-danger': error !== ''}"
    >
      <input
        v-model="code"
        name="code"
        class="form-control form-control-lg"
        :class="{'is-invalid': error !== ''}"
        type="text"
        :disabled="disableVerify"
        @keyup="verifyCodeKeyUp"
        @input="verifyCode"
      >
      <span
        v-cloak
        v-show="error !== ''"
        class="invalid-feedback"
      >
        {{ error }}
      </span>
    </div>
    <div class="form-group">
      <button
        id="verifyBtn"
        type="submit"
        :disabled="disableVerify"
        class="btn btn-primary btn-lg btn-block"
      >
        Sign In
      </button>
    </div>
    <div class="form-group">
      <div>
        Choose a <a
          href="#"
          @click="switchAuthMethod"
        >different two-factor authentication method</a> to sign in.
      </div>
    </div>
  </form>
</template>

<script>
import { defineComponent } from 'vue';
import { useAwr } from '@/awr/stores/awr';
import { executeRequest } from '@/utils/ajax';

export default defineComponent({
  name: 'TwoFactorForm',
  data() {
    const awr = useAwr();

    return {
      two_fa_payload: awr.$state.twoFaPayload,
      code: '',
      disableVerify: false,
      error: '',
      useBackupCode: false,
    };
  },
  methods: {
    validateCode() {
      const length = this.useBackupCode ? 9 : 6;
      if (this.code.length === 0) {
        this.error = (this.useBackupCode ? 'Missing backup code.' : 'Missing code.');
      } else if (this.code.length !== length) {
        this.error = (this.useBackupCode ? 'Your backup code must be 9 characters long.' : 'Your code must contain 6 digits.');
      } else {
        this.error = '';
      }

      return this.error === '';
    },

    verifyCodeKeyUp(event) {
      // verify when Enter is pressed
      if (event.keyCode === 13) {
        this.verify();
      }
    },

    verifyCode(event) {
      // check minimum code length (6 for OTP, 9 for backup code)
      const length = this.useBackupCode ? 9 : 6;
      if (this.code.length < length) {
        return;
      }

      // verify once the code reaches the expected length.
      this.verify();
    },

    verify() {
      if (!this.validateCode()) {
        return;
      }

      this.disableVerify = true;
      this.error = '';

      const twoFAPayload = $('#2fa_payload').val();

      executeRequest({
        type: 'POST',
        url: 'signin',
        data: {
          action: 'verify_code',
          two_fa: twoFAPayload,
          code: this.code,
          backup: this.useBackupCode ? 1 : 0,
        },
      })
        .then((msg) => {
          const responseArr = msg.split(':');
          if (responseArr[0] === 'OK') {
            // redirect to index login is done
            window.location.href = '/';
          } else {
            this.disableVerify = false;
            this.error = responseArr[1];
          }
        });
    },

    switchAuthMethod() {
      // suppress validation while switching the authentication method
      this.useBackupCode = !this.useBackupCode;

      this.code = '';
      this.error = '';
    },
  },
});
</script>

<style scoped lang="scss">

</style>
